const formatBrand = (brand?: string) => {
  if (!brand) return 'Card';
  const b = brand.toLowerCase();
  if (b === 'amex') return 'American Express';
  return brand.charAt(0).toUpperCase() + brand.slice(1);
};

const brandToLogoSrc = (brand?: string) => {
  if (!brand) return undefined;
  const key = brand.toLowerCase();
  return `/cards/${key}.svg`;
};

const CardBrandLogo = ({ brand }: { brand?: string }) => {
  const src = brandToLogoSrc(brand);

  if (!src) {
    return (
      <span className="text-xs font-semibold text-gray-700">
        {(brand ?? 'CARD').toString().toUpperCase()}
      </span>
    );
  }

  return (
    <img
      src={src}
      alt={formatBrand(brand)}
      className="h-10 w-auto"
      onError={(e) => {
        (e.currentTarget as HTMLImageElement).style.display = 'none';
      }}
    />
  );
};

export default CardBrandLogo;
